import React from 'react'
import HorizontalRule from "./../UI/HorizontalRule/HorizontalRule"
import { Card, CardHeading, CardHeadingDecoration, CardAvatar, CardText, CardButton, CardRow } from "./../UI/Card/Card"
import { CruiseShip, BookActions, EarlyBirdDiscount } from "./../Content/Content"
import "./Home.scss";

const Home = () => {
  return (
    <div className="content-wrapper">
      <p className='intro-text'>
        Unsere 21. Kongress-Schiffsreise führt Sie auf der <CruiseShip className="link-simple"/> von Barcelona aus über Cannes, Genua, La Spezia, Civitavecchia und Palma de Mallorca durch das Mittelmeer. 
        Verbinden Sie die Annehmlichkeiten der Kreuzfahrt mit einer interessanten und vielseitigen Fortbildungsveranstaltung für Zahnärzte, Zahntechniker und Ihr gesamtes Team.
      </p>
      <HorizontalRule type="wave" />
      <p className='text-center'>
        Die MSC Grandiosa ist ein großes und modernes Luxus-Kreuzfahrtschiff, benannt nach dem italienischen Wort für "Größe" oder "Pracht". Es ist 331 Meter lang und bietet Platz für bis zu 6.300 Passagiere. An Bord finden sich vielfältige Unterhaltungs- und Entspannungsmöglichkeiten. Darunter die zentral gelegene und überdachte "Galleria Grandiosa" mit einer 90m langen LED-Decke, zahlreiche Restaurants und Bars, ein umfangreicher Wellnessbereich, sowie ein Hightech-Theater mit exklusiven Shows. 
      </p>
      <HorizontalRule type="wave" />
      <BookActions />
      <EarlyBirdDiscount className="text-intro text-center" />
      <HorizontalRule type="wave" />
      <CardRow>
        <Card width="50%"> 
          <CardHeading>
            Flyer &<br />Anmeldungsformulare
            <CardHeadingDecoration type="tripleWave" />
          </CardHeading>
          <CardAvatar 
            src={require("./../../assets/images/fishes-on-wall-1.webp")} 
            srcFallback={require("./../../assets/images/fishes-on-wall-1.png")} 
          />
          <CardText>
            <p style={{marginBottom: '0.5rem'}}>Formulare zum Ausdrucken in der Praxis</p>
            <p><a href="./flyer/Reiseanmeldung-2026.pdf" className='link-underline'>Reiseanmeldung</a></p>
            <p><a href="./flyer/Kongressanmeldung-2026.pdf" className='link-underline'>Kongressanmeldung</a></p>
            <p><a href="./flyer/Bordmanifest-2026.pdf" className='link-underline'>Bordmanifest</a></p>
          </CardText>
          <CardButton 
            file={true} 
            link="./flyer/flyer-2026.pdf"
          >
            Flyer Jetzt Downloaden
          </CardButton>
        </Card>
        <Card width="50%">
          <CardHeading>
            Kontakt
            <CardHeadingDecoration type="tripleWave" />
          </CardHeading>
          <CardAvatar 
            src={require("./../../assets/images/fishes-on-wall-2.webp")} 
            srcFallback={require("./../../assets/images/fishes-on-wall-2.png")} 
          />
          <CardText>
            <p>Gesundheitszentrum Fortbildungsinstitut Bernau GmbH</p>
            <p>Tel 03338 – 752716 / Fax 03338 – 752729</p>
          </CardText>
          <CardButton link="/contact">
            Kontakt
          </CardButton>
        </Card>
      </CardRow>
      <HorizontalRule type="wave" />
    </div>
  )
}

export default Home